var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPanelSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.46582,
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3537 16.3535H8.64631C8.28937 16.3535 8 16.6429 8 16.9998C8 17.3568 8.28937 17.6461 8.64631 17.6461H23.3537C23.7107 17.6461 24 17.3568 24 16.9998C24 16.6429 23.7107 16.3535 23.3537 16.3535Z",
    fill: "#002447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3537 11.4512H8.64631C8.28937 11.4512 8 11.7405 8 12.0975C8 12.4544 8.28937 12.7438 8.64631 12.7438H23.3537C23.7107 12.7438 24 12.4544 24 12.0975C24 11.7405 23.7107 11.4512 23.3537 11.4512Z",
    fill: "#002447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3537 21.2559H8.64631C8.28937 21.2559 8 21.5452 8 21.9022C8 22.2591 8.28937 22.5485 8.64631 22.5485H23.3537C23.7107 22.5485 24 22.2591 24 21.9022C24 21.5452 23.7107 21.2559 23.3537 21.2559Z",
    fill: "#002447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPanelSvg);
export default __webpack_public_path__ + "static/media/menu-panel-svg.d9a11d08b75fdc83dd94929f4bffb501.svg";
export { ForwardRef as ReactComponent };